import type { HttpResp } from '@/http'
import http from '@/http'

import { JsonContentType } from './constant'
import type { MiniProgramEntity, WxMiniProgramsAuditInfo, WxMiniProgramsError, WxProgramsAuthorizationStatus } from './types'

/**
 * 获取微信小程序授权二维码
 * @return {*}
 */
export async function getPreAuthQRCode(): Promise<string> {
    const res = await http.get<unknown, HttpResp<string>>('/api/v1/miniProgram/preAuthQRCode')
    return res.content
}

/**
 * 小程序提交审核
 * @return {*}
 */
export async function submitAudit(): Promise<boolean> {
    const res = await http.put<unknown, HttpResp<boolean>>('/api/v1/miniProgram/submitAudit')
    return res.success
}

/**
 * 获取授权结果
 * @param {UpdatePagePayload} data
 */
export async function getWxMiniProgramsAuthorizationResult(): Promise<{
    authStatus: WxProgramsAuthorizationStatus
    errorContent: WxMiniProgramsError
}> {
    const res = await http.get<unknown, HttpResp<{ authStatus: WxProgramsAuthorizationStatus; errorContent: WxMiniProgramsError }>>(
        'api/v1/miniProgram/authInfo'
    )
    return res.content
}

/**
 * 保存微信小程序审核信息
 * @param {UpdatePagePayload} data
 */
export async function saveWxMiniProgramsAuditInfo(params: WxMiniProgramsAuditInfo): Promise<boolean> {
    const res = await http.put<unknown, HttpResp>('api/v1/miniProgram/saveAuditInfo', params, {
        headers: JsonContentType
    })
    return res.success
}

/**
 *
 * @returns 获取微信小程序信息
 */
export async function getWxProgramsInfo(): Promise<MiniProgramEntity> {
    const res = await http.get<unknown, HttpResp<MiniProgramEntity>>('api/v1/miniProgram/getInfo')
    return res.content
}

/**
 *
 * @returns 获取微信小程序体验版二维码
 */
export async function getTrialQRCode(): Promise<string> {
    const res = await http.get<unknown, HttpResp<string>>('api/v1/miniProgram/getTrialQRCode')
    return res.content
}
/**
 *
 * @returns 获取微信小程序正式版二维码
 */
export async function getProductionQRCode(): Promise<string> {
    const res = await http.get<unknown, HttpResp<string>>('api/v1/miniProgram/getQRCode')
    return res.content
}

/**
 *
 * @returns 小程序撤销审核
 */
export async function cancelMiniProgramAudit(): Promise<boolean> {
    const res = await http.post<unknown, HttpResp<boolean>>('api/v1/miniProgram/revokeAudit')
    return res.success
}
